export default "__VITE_ASSET__44001911__"